export default (gltf) => {
  return {
    involuntary: gltf.animations,
  };
};
